import { render, staticRenderFns } from "./TaskTemplatesList.vue?vue&type=template&id=2a4cc054&scoped=true"
import script from "./TaskTemplatesList.vue?vue&type=script&lang=js"
export * from "./TaskTemplatesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4cc054",
  null
  
)

export default component.exports